var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:black;}\n\t.st4{fill:none;stroke:black;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "5.46,38.14 5.46,1.5 23.41,1.5 34.17,12.26 34.17,38.14  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.79,3l9.88,9.88v23.76H6.96V3H22.79 M24.03,0H3.96v39.64h31.71v-28L24.03,0L24.03,0z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.83,46.5 13.83,9.86 31.77,9.86 42.54,20.62 42.54,46.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.15,11.36l9.88,9.88V45H15.33V11.36H31.15 M32.4,8.36H12.33V48h31.71V20L32.4,8.36L32.4,8.36z"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "41.16,20.49 31.91,20.49 31.91,10.36  "
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.67,11.64L35.67,11.64L24.03,0H3.96v39.64h8.36V48h31.71V20L35.67,11.64z M33.41,13.61l5.38,5.38h-5.38 V13.61z M6.96,36.64V3h15.83l5.36,5.36H12.33v28.28H6.96z M15.33,45V11.36h15.08v10.63h10.63V45H15.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateB);
export default __webpack_public_path__ + "static/media/duplicate-b.233361915270414291a6b4e060daa7e8.svg";
export { ForwardRef as ReactComponent };